/**
 * @generated SignedSource<<ce86af37506bed59edb849c793852423>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MilestonePickerMilestone$data = {
  readonly closed: boolean;
  readonly dueOn: string | null;
  readonly id: string;
  readonly progressPercentage: number;
  readonly title: string;
  readonly url: string;
  readonly " $fragmentType": "MilestonePickerMilestone";
};
export type MilestonePickerMilestone$key = {
  readonly " $data"?: MilestonePickerMilestone$data;
  readonly " $fragmentSpreads": FragmentRefs<"MilestonePickerMilestone">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "MilestonePickerMilestone"
};

(node as any).hash = "6e60a0afad7137ee439461ddc4a8d63e";

export default node;
